import React, { useEffect, useRef, useState } from "react";
import './navbar.scss';
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <>
      <section className='main_navbar'>
        <div className="custom-container">
          <div className='inner_navbar'>
            <Link to="/">
              <img src='\assets\logo.svg' />
            </Link>
            {/* <button><img src='\assets\buttonn.svg' /> ENG </button> */}
          </div>
        </div>

      </section>

    </>
  )
}

export default Navbar
